import type { SetStateAction, Dispatch } from 'react';
import { useEffectOnceOnMount } from '@wix/da-hooks/pkg/useEffectOnceOnMount';
import { PapiProductV3 } from '@wix/da-papi-types';

interface UseOpenPopupOnIdParamProps {
  monthlyPackageProduct: PapiProductV3;
  yearlyPackageProduct: PapiProductV3;
  setSelectedPackage: Dispatch<SetStateAction<number[]>>;
  setIsPopupOpen: Dispatch<SetStateAction<boolean>>;
}

export function useOpenCPPopupOnIdParam({
  monthlyPackageProduct,
  yearlyPackageProduct,
  setSelectedPackage,
  setIsPopupOpen,
}: UseOpenPopupOnIdParamProps) {
  useEffectOnceOnMount(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const subproductIdFromUrl = parseInt(urlParams.get('id') || '', 10);

    if (!subproductIdFromUrl) {
      return;
    }

    if (
      monthlyPackageProduct.subproductId !== subproductIdFromUrl &&
      yearlyPackageProduct.subproductId !== subproductIdFromUrl
    ) {
      return;
    }

    setSelectedPackage([
      monthlyPackageProduct.subproductId,
      yearlyPackageProduct.subproductId,
    ]);
    setIsPopupOpen(true);

    // Remove 'id' from the URL
    urlParams.delete('id');
    const newUrl = urlParams.toString()
      ? `${window.location.pathname}?${urlParams.toString()}`
      : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
  });
}

export default useOpenCPPopupOnIdParam;
